<template>
<v-app>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            
            <div
              class="wizard-step"
              data-wizard-type="step" data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información del Usuario
                  </h3>
                  <div class="wizard-desc">
                    Configure datos de la empresa
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <b-form class="form" @submit.stop.prevent="onSubmit">
                
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos de la empresa
                  </h4>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Rut Usuario</label>
                        <b-form-input
                          class="form-control"
                          id="example-input-1"
                          name="example-input-1"
                          v-model="$v.form.rutEmpresa.$model"
                          :state="validateState('rutEmpresa')"
                          aria-describedby="input-rut-live-feedback" autofocus
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-rut-live-feedback">
                          Rut es requerido y debe ser valido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Nombre o Razón Social</label>
                    <b-form-input
                      class="form-control"
                      type="text"
                      id="example-input-3"
                      name="example-input-3"
                      v-model="$v.form.nombre.$model"
                      :state="validateState('nombre')"
                      aria-describedby="input-3-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-3-live-feedback">
                      Nombre es requerido.
                    </b-form-invalid-feedback>
                  </div>
                  
                  <div class="form-group">
                    <label>Css</label>
                    <b-form-input
                      class="form-control"
                      type="text"
                      id="example-input-4"
                      name="example-input-4"
                      v-model="$v.form.css.$model"
                      :state="validateState('css')"
                      aria-describedby="input-4-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-4-live-feedback">
                      Css es requerido
                    </b-form-invalid-feedback>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>logo</label>
                        <b-form-input
                          class="form-control"
                          type="tel"
                          id="logo"
                          name="logo"
                          v-model="$v.form.logo.$model"
                          :state="validateState('logo')"
                          aria-describedby="input-logo-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-logo-feedback">
                          Icono o logo es requerido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Email</label>
                        <b-form-input
                        class="form-control"
                        type="email"
                        id="example-input-5"
                        name="example-input-5"
                        v-model="$v.form.email.$model"
                        :state="validateState('email')"
                        aria-describedby="input-5-live-feedback"
                      ></b-form-input>

                      <b-form-invalid-feedback id="input-5-live-feedback">
                        Email es requerido.
                      </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Empresa Activada</label>
                         <v-switch v-model="switch1"></v-switch>
                        
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>
                  <button 
                      class="btn btn-primary align-self-center"
                      type="submit"
                    >
                      Actualizar
                    </button>
                  
                </div>
                <!--end: Wizard Step 1-->

                
              </b-form>
            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</v-app>
</template>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>
<style>
.transparent {
  background: transparent !important;
}
.perfil-menu {
  background: #fff;
}
.perfil-body {
  background: #fff;
}
</style>

<script>
import { mapState } from "vuex";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import { validationMixin } from "vuelidate";
import { GET_COMPANY_ACCOUNT, UPDATE_COMPANY_ACCOUNT } from "@/core/services/store/company.module";
import {
  email,
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  name: "edicionEmpresa",
  data() {
    return {
      isMounted : false,
      wizard:null,
      switch1: true,
      step:1,
       form: {
        codigoEmpresa:"",
        rutEmpresa:"",
        nombre:"",
        logo:"",
        css:"",
        email:"",
        activo:true
      },
      };
  },
  validations: {
    form: {
      
      rutEmpresa: {
        required,
      },
      nombre: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(75)
      },
      logo: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(75)
      },
      email: {
        required,
        email,
        maxLength: maxLength(75)
      },
      css: {
        required
      }
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Hemos enviado la bienvenida y contraseña de acceso al cliente.`, {
        title: 'Cliente creado exitosamente',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.actualizarEmpresa();
    },
    actualizarEmpresa(){
      const codigoEmpresa = this.companyAccount.codigoEmpresa;
      const rutEmpresa = this.companyAccount.rutEmpresa;
      const nombre = this.$v.form.nombre.$model;
      const logo = this.$v.form.logo.$model;
      const emailNotificaciones = this.$v.form.email.$model;
      const estiloCss = this.$v.form.css.$model;
      setTimeout(() => {
        this.$store
          .dispatch(UPDATE_COMPANY_ACCOUNT, {  codigoEmpresa, rutEmpresa, nombre, estiloCss, logo, emailNotificaciones, activa:this.switch1 })
          // go to which page after successfully login
          .then(() => this.makeToast());

        /*submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );*/
      }, 500);
    },
    getCompanyAccount() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_COMPANY_ACCOUNT, this.$route.params.codigoEmpresa)
          .then((response)=>{
            this.$v.form.rutEmpresa.$model = `${response.rutEmpresa}-${response.dvEmpresa}`,
          this.$v.form.nombre.$model = response.nombre,
          this.$v.form.css.$model = response.estiloCss,
          this.$v.form.logo.$model = response.logo,
          this.$v.form.email.$model = response.emailNotificaciones,
            this.$Progress.finish()});
    },
  },
  beforeUpdate() {
    console.log("beforeUpdate " + JSON.stringify(this.companyAccount)); 
      if(!this.isMounted){
        console.log("actualizado " + JSON.stringify(this.companyAccount)); 
        this.$nextTick(function() {
          console.log("nextTick", JSON.stringify(this.companyAccount));
          this.$v.form.rutEmpresa.$model = `${this.companyAccount.rutEmpresa}-${this.companyAccount.dvEmpresa}`;
          this.$v.form.nombre.$model = this.companyAccount.nombre;
          this.$v.form.css.$model = this.companyAccount.estiloCss;
          this.$v.form.logo.$model = this.companyAccount.logo;
          this.$v.form.email.$model = this.companyAccount.emailNotificaciones;
        });
        this.isMounted = true;
      }
  },
  mounted() {
    this.getCompanyAccount();
    // Initialize form wizard
    this.wizard = new KTWizard("kt_wizard_v2", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    this.wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    this.wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      companyAccount: state => state.company.companyAccount,
      rutEmpresa: function(){
        return `${this.companyAccount.rutEmpresa}-${this.companyAccount.dvEmpresa}`;
      },
    })
  }
};
</script>